/**
 * 郵便番号自動検索関数
 * yubinbango.js ではカスタマイズが難しいので、自作する
 */
window.searchZipcode = async function(e, prefecture, address) {
    const zipcode = e.target.value;

    if (zipcode.length == 7) {
        // axios を使って API を呼び出し住所検索する
        const response = await axios({
            url: 'https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + zipcode,
            adapter: axiosJsonpAdapter,
            method: 'get'
        });
        if (response.data.results) {
            if (response.data.results[0].address1) {
                // select の表示名を検索して選択する
                _.forEach(prefecture.options, function(option) {
                    if (option.text == response.data.results[0].address1) {
                        prefecture.value = option.value;
                    }
                });
            }
            if (response.data.results[0].address2) {
                address.value = response.data.results[0].address2 + response.data.results[0].address3;
            }
        }
    }
}

window.autoKana = function(family_name, first_name, family_name_kana, first_name_kana) {
    $.fn.autoKana('input[name=' + family_name.name + ']', 'input[name=' + family_name_kana.name + ']', {
        katakana: true
    });
    $.fn.autoKana('input[name=' + first_name.name + ']', 'input[name=' + first_name_kana.name + ']', {
        katakana: true
    });
}
